import { VerifyEmailPage } from "@cavort/auth";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	token: z.string().catch(""),
});

export const Route = createFileRoute("/_auth/verify-email")({
	validateSearch: searchSchema,
	component: VerifyEmailRoute,
});

function VerifyEmailRoute() {
	const { token } = Route.useSearch();
	const navigate = useNavigate();
	return <VerifyEmailPage token={token} onLoginClick={() => navigate({ to: "/login" })} />;
}
